import React from 'react';

const MultiLineField: React.FC<{ text: string }> = ({ text }) => {
  const lines = text.split(/\r?\n/);
  return (
    <>
      {lines.map((line, index, list) => (
        <span key={index}>
          {line}
          {index < list.length - 1 && <br aria-hidden="true" />}
        </span>
      ))}
    </>
  );
};

export default MultiLineField;
